<!-- contratto dipendente -->
<div class="card">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'current_contract' ? 'current' : ''" (click)="toggleModal('current_contract')">
    <h3>{{ "CURRENT_CONTRACT" | translate }}</h3>
  </div>
  <div class="card-body" *ngIf="openContractTab == 'current_contract'">
    <div class="font-medium-1 d-flex align-items-start">
      <div class="col-md-4 col-12 pl-0">
        <strong>{{ "CONTRACT_DETAILS" | translate }}</strong>
        <div>
          {{ "CONTRACT_TYPE" | translate }}: <strong>{{ currentContract.name }}</strong>
        </div>
        <div *ngIf="_manageContract.typeIsApprendistato">
          {{ "DURATION" | translate }}: <strong>{{ currentContract.duration }} {{ "DAYS" | translate }}</strong>
        </div>
        <div>
          {{ "LEVEL" | translate }}: <strong>{{ currentContract.level }}</strong>
        </div>
        <div *ngIf="_manageContract.typeIsApprendistato || _manageContract.typeIsStage">
          {{ "TUTOR" | translate }}: <strong>{{ currentContract.tutor }}</strong>
        </div>
        <div *ngIf="!_manageContract.typeIsStage">
          {{ "CONTRACT_TRIAL_DAYS" | translate }}: <strong>{{ currentContract.trial }}</strong>
        </div>
        <div>
          {{ "DUTY" | translate }}: <strong>{{ currentContract.figure }}</strong>
        </div>
        <div>
          {{ "CONTRACT_PROGRAM" | translate }}: <strong>{{ currentContract.program }}</strong>
        </div>
        <div>
          {{ "START_DATE" | translate }}: <strong>{{ _utilsService.formatDate(currentContract.start_date) }}</strong>
        </div>
        <div *ngIf="currentContract.end_date">
          {{ "END_DATE" | translate }}: <strong>{{ _utilsService.formatDate(currentContract.end_date) }}</strong>
        </div>
        <div>
          {{ "REFERENCE_OFFICE" | translate }}: <strong>{{ currentContract.company_office_name }}</strong>
        </div>
        <div *ngIf="currentContract.closed_at">
          {{ "RESIGNATION_DATE" | translate }}: <strong>{{ _utilsService.formatDate(currentContract.closed_at) }}</strong>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <strong>{{ "EMPLOYEE_COSTS" | translate }}</strong>
        <div *ngIf="!_manageContract.typeIsStage">
          {{ "SALARY_YEARLY_GROSS" | translate }}: <strong>{{ currentContract.ral }}&euro;</strong>
        </div>
        <div>
          {{ "MONTHLY_BONUSES" | translate }}: <strong>{{ currentContract.bonus }}&euro;</strong>
        </div>
        <div>
          {{ "PRODUCTION_BONUS" | translate }}: <strong>{{ currentContract.production_bonus }}&euro;</strong>
        </div>
        <div>
          {{ (_manageContract.typeIsStage ? "SALARY_MONTH" : "SALARY_MONTH_12") | translate }}: <strong>{{ currentContract.net_monthly_12 }}&euro;</strong>
        </div>
        <div *ngIf="!_manageContract.typeIsStage">
          {{ "SALARY_MONTH_13" | translate }}: <strong>{{ currentContract.net_monthly_13 }}&euro;</strong>
        </div>
        <div>
          {{ "TOTAL_SALARY_DAILY" | translate }}: <strong>{{ currentContract.total_daily }}&euro;</strong>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <strong>{{ "BONUS_TICKET" | translate }}</strong>
        <div>
          {{ "TICKET_TYPE" | translate }}: <strong>{{ currentContract.ticket_type | translate }}</strong>
        </div>
        <div>
          {{ "TICKET_MONTH_NUMBER" | translate }}: <strong>{{ currentContract.ticket_month_number }}</strong>
        </div>
        <div>
          {{ "TICKET_VALUE" | translate }}: <strong>{{ currentContract.ticket_value }}&euro;</strong>
        </div>
        <div>
          {{ "TICKET_TOTAL_MONTH" | translate }}: <strong>{{ currentContract.ticket_value * currentContract.ticket_month_number }}&euro;</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<!--aggiorna contratto-->
<div class="card" *ngIf="!is_resigned">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'update_contract' ? 'current' : ''" (click)="toggleModal('update_contract')">
    <h3>{{ "UPDATE_CONTRACT" | translate }}</h3>
  </div>
  <div class="card-body" *ngIf="openContractTab == 'update_contract'">
    <div class="row">
      <div class="form-group col-12 col-md-5">
        <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          id="contract_id"
          [items]="_contractService.list"
          bindLabel="name"
          bindValue="id"
          [closeOnSelect]="true"
          [clearable]="false"
          [(ngModel)]="_manageContract.data.contract"
          (change)="_manageContract.changeContract($event); contract_is_changed = true"></ng-select>
      </div>
      <div class="form-group col-12 col-md-6 col-xl-4" *ngIf="_manageContract.typeIsApprendistato">
        <label for="contract_level">{{ "DURATION" | translate }}<sup class="text-danger">*</sup></label>
        <input
          type="number"
          min="1"
          max="36"
          [defaultValue]="3"
          class="form-control {{ !_manageContract.contractDuration ? 'is-invalid' : '' }}"
          [(ngModel)]="_manageContract.contractDuration"
          [ngModelOptions]="{ standalone: true }"
          (change)="_manageContract.updateData(); contract_is_changed = true" />
      </div>
      <div [class]="'form-group col-12 col-md-3'" *ngIf="!_manageContract.typeIsStage">
        <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          *ngIf="_manageContract.levels_for_select.length > 0"
          id="contract_level"
          [(ngModel)]="_manageContract.data.level"
          [closeOnSelect]="true"
          [clearable]="false"
          [openOnEnter]="false"
          [virtualScroll]="true"
          class="{{ !_manageContract.data.level ? 'is-invalid' : '' }}"
          (change)="_manageContract.changeLevel(true, false, true); contract_is_changed = true">
          <ng-option *ngFor="let lvl of _manageContract.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
        </ng-select>
        <select *ngIf="_manageContract.levels_for_select.length < 1" disabled class="form-control"></select>
      </div>
      <div class="form-group col-xl-4 col-md-4 col-12">
        <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          id="contract_program"
          [items]="_contractService.programs"
          bindLabel="label"
          class="{{ !_manageContract.data.program ? 'is-invalid' : '' }}"
          bindValue="value"
          [closeOnSelect]="true"
          [clearable]="false"
          [(ngModel)]="_manageContract.data.program"
          (change)="contract_is_changed = true">
        </ng-select>
      </div>
      <div class="form-group col-12 col-md-6 col-xl-3" *ngIf="_manageContract.typeIsApprendistato || _manageContract.typeIsStage">
        <label for="contract_level">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          [closeOnSelect]="true"
          [clearable]="false"
          [(ngModel)]="_manageContract.data.tutor_hash"
          (change)="_manageContract.updateData(); contract_is_changed = true"
          class="{{ !_manageContract.tutors ? 'is-invalid' : '' }}">
          <ng-option *ngFor="let tutor of _manageContract.tutors" [value]="tutor.hash">{{ tutor.complete_name }}</ng-option>
        </ng-select>
      </div>
      <div class="form-group col-12" [ngClass]="_manageContract.typeIsApprendistato ? 'col-md-5' : 'col-md-6'">
        <label for="contract_role">{{ "DUTY" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          bindValue="id"
          bindLabel="name"
          id="contract_role"
          [(ngModel)]="_manageContract.data.role"
          [closeOnSelect]="true"
          [clearable]="false"
          [openOnEnter]="false"
          class="{{ !_manageContract.data.role ? 'is-invalid' : '' }}"
          [virtualScroll]="true"
          [items]="_userFigureService.list"
          (change)="contract_is_changed = true"></ng-select>
      </div>
      <div class="form-group col-md-6 col-12">
        <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger" *ngIf="_manageContract.data.contract !== 1">*</sup></label>
        <input
          type="date"
          id="contract_start_date"
          [readOnly]="(_manageContract.typeIsIndeterminate || _manageContract.typeIsApprendistato) && _manageContract.data.start_date"
          (change)="_manageContract.updateData(); contract_is_changed = true"
          class="form-control {{ !_manageContract.data.end_date && !_manageContract.typeIsIndeterminate ? 'is-invalid' : '' }}"
          [(ngModel)]="_manageContract.data.start_date" />
      </div>
      <div class="form-group col-12 col-md-6" *ngIf="!_manageContract.typeIsIndeterminate">
        <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger" *ngIf="_manageContract.data.contract !== 1">*</sup></label>
        <input
          type="date"
          id="contract_end_date"
          [readOnly]="_manageContract.typeIsApprendistato"
          (change)="_manageContract.updateData(); contract_is_changed = true"
          class="form-control {{ !_manageContract.data.end_date && !_manageContract.typeIsIndeterminate ? 'is-invalid' : '' }}"
          [(ngModel)]="_manageContract.data.end_date" />
      </div>
      <div class="form-group col-12 col-md-6">
        <label for="company_office">{{ "REFERENCE_OFFICE" | translate }}<sup class="text-danger">*</sup></label><ng-select
          bindValue="id"
          bindLabel="name"
          id="company_office"
          [(ngModel)]="_manageContract.data.company_office_id"
          [closeOnSelect]="true"
          [clearable]="false"
          [openOnEnter]="false"
          class="{{ !_manageContract.data.company_office_id ? 'is-invalid' : '' }}"
          [virtualScroll]="true"
          (change)="contract_is_changed = true"
          [items]="company_offices_list"></ng-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <h4 class="mb-0 mt-2">{{ "EMPLOYEE_COSTS" | translate }}</h4>
      </div>
      <!-- soglie per il prossimo livello -->
      <div class="form-group col-12" *ngIf="_manageContract.current_lvl && _manageContract.next_lvl && !_manageContract.typeIsStage && _manageContract.data.level != 'B3'">
        <p class="mb-0 font-small-4">
          {{ "RAL_FOR_LEVEL" | translate }} <strong>{{ _manageContract.next_lvl.level }}</strong>&nbsp;
          <em>{{ _utilsService.addDotsToNumber(_manageContract.next_lvl.salary_yearly_gross) }}&euro;</em>
        </p>
      </div>
      <div class="form-group col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
        <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
        <div class="input-group input-group-merge {{ !_manageContract.data.salary_yearly_gross ? 'is-invalid' : '' }}">
          <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="!_manageContract.data.contract ? 'bg-readonly' : ''">&euro;</span>
          </div>
          <input *ngIf="!_manageContract.data.contract; else ralInput" readonly type="text" [(ngModel)]="_manageContract.data.salary_yearly_gross" class="form-control" />
          <ng-template #ralInput>
            <input
              type="text"
              [(ngModel)]="_manageContract.data.salary_yearly_gross"
              id="salary_yearly_gross"
              class="form-control bg-white"
              [ngClass]="!_manageContract.data.salary_yearly_gross ? 'is-invalid' : ''"
              (change)="transformRal($any($event.target).value); contract_is_changed = true" />
          </ng-template>
        </div>
      </div>
      <div class="form-group col-md-3 col-12" *ngIf="!_manageContract.typeIsStage">
        <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input
            type="text"
            [readonly]="!_manageContract.data.contract"
            [(ngModel)]="_manageContract.data.bonus"
            id="bonus"
            (change)="_manageContract.updateData('monthly_bonus'); contract_is_changed = true"
            class="form-control" />
        </div>
      </div>
      <div class="form-group col-md-3 col-12" *ngIf="!_manageContract.typeIsStage">
        <label for="production_bonus">{{ "PRODUCTION_BONUS" | translate }}</label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input
            type="text"
            [readonly]="!_manageContract.data.contract"
            [(ngModel)]="_manageContract.data.production_bonus"
            id="production_bonus"
            (change)="_manageContract.updateData('monthly_production_bonus'); contract_is_changed = true"
            class="form-control" />
        </div>
      </div>
      <div class="col-12"></div>
      <div class="form-group col-xl-4 col-md-6 col-12">
        <label for="net_monthly_12">{{ _manageContract.typeIsStage ? ("SALARY_MONTH" | translate) : ("SALARY_MONTH_12" | translate) }} <sup class="text-danger">*</sup></label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text {{ !_manageContract.typeIsStage ? 'bg-readonly' : '' }}">&euro;</span>
          </div>
          <input
            [readOnly]="!_manageContract.typeIsStage"
            type="text"
            id="net_monthly_12"
            class="form-control"
            [(ngModel)]="_manageContract.data.net_monthly_12"
            [value]="_manageContract.data.net_monthly_12"
            (change)="_manageContract.updateData(); contract_is_changed = true" />
        </div>
      </div>
      <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
        <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}<sup class="text-danger">*</sup></label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text bg-readonly">&euro;</span>
          </div>
          <input readonly="readonly" type="text" id="net_monthly_13" class="form-control" (change)="contract_is_changed = true" [value]="_manageContract.data.net_monthly_13" />
        </div>
      </div>
      <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContract.typeIsStage">
        <label for="total_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}<sup class="text-danger">*</sup></label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text bg-readonly">&euro;</span>
          </div>
          <input readonly="readonly" type="text" id="total_monthly_13" class="form-control" (change)="contract_is_changed = true" [value]="_manageContract.data.total_net_monthly_13" />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!_manageContract.typeIsStage">
      <div class="form-group col-12">
        <h4 class="mb-0 mt-2">{{ "BONUS_TICKET" | translate }}</h4>
      </div>
      <div class="form-group col-xl-6 col-md-6 col-12">
        <label for="ticket_card">{{ "TICKET_CARD" | translate }}</label>
        <input type="text" maxlength="7" id="ticket_card" class="form-control" (change)="contract_is_changed = true" [(ngModel)]="_manageContract.data.ticket_card" />
      </div>
      <div class="form-group col-xl-6 col-md-6 col-12">
        <label for="ticket_type">{{ "TICKET_TYPE" | translate }}</label>
        <select
          name="ticket_type"
          id="ticket_type"
          class="form-control"
          [(ngModel)]="_manageContract.data.ticket_type"
          (change)="_manageContract.data.ticket_month_number = _manageContract.data.ticket_type === 'variabile' ? 20 : 0; contract_is_changed = true">
          <option disabled>{{ "TICKET_TYPE" | translate }}</option>
          <option value="fisso">{{ "STATIC" | translate }}</option>
          <option value="variabile">{{ "VARIABLE" | translate }}</option>
        </select>
      </div>
      <div class="form-group col-xl-4 col-md-6 col-12">
        <label for="ticket_month_number">{{ "TICKET_MONTH_NUMBER" | translate }}</label>
        <input
          type="number"
          id="ticket_month_number"
          class="form-control"
          [(ngModel)]="_manageContract.data.ticket_month_number"
          (change)="_manageContract.updateData(); contract_is_changed = true"
          [readOnly]="_manageContract.data.ticket_type === 'variabile'" />
      </div>
      <div class="form-group col-xl-4 col-md-6 col-12">
        <label for="ticket_value">{{ "TICKET_DAILY_VALUE" | translate }}</label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input type="text" id="ticket_value" [(ngModel)]="_manageContract.data.ticket_value" (change)="transformTicketValue($any($event).target)" class="form-control" />
        </div>
      </div>
      <div class="form-group col-xl-4 col-md-6 col-12">
        <label for="total_monthly_13">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text bg-readonly">&euro;</span>
          </div>
          <input readonly="readonly" type="text" class="form-control" [value]="_utilsService.addDotsToNumber(_manageContract.data.ticket_value * _manageContract.data.ticket_month_number)" />
        </div>
      </div>
    </div>
    <div class="row border-top pt-2 mt-1" *ngIf="contract_is_changed">
      <div class="form-group col-12">
        <h4 class="mb-0 mt-2">{{ "VALID_SINCE_DATE" | translate }}</h4>
      </div>
      <div class="form-group col-xl-3 col-md-6 col-12">
        <input type="date" id="valid_since" [min]="today_date" class="form-control {{ !valid_since ? 'is-invalid' : '' }}" [(ngModel)]="valid_since" />
      </div>
    </div>
  </div>
  <div class="card-footer d-flex align-items-end justify-content-between" *ngIf="openContractTab == 'update_contract'">
    <div id="contract-daily-cost" [ngClass.xl]="'flex-basis-50'" [ngClass.md]="'flex-basis-50'" [ngClass.sm]="'mb-1'">
      {{ "TOTAL_SALARY_DAILY" | translate }}
      <strong>&euro; {{ _manageContract.data.total_daily }}</strong>
    </div>
    <div class="text-right">
      <button class="btn btn-primary" [disabled]="!contract_is_changed || valid_since == null" type="button" (click)="updateContract()">{{ "SAVE" | translate }}</button>
    </div>
  </div>
</div>

<!--archivio contratti-->
<div class="card" *ngIf="_authenticationService.hasCapability('view_employee_contract_history') && currentUser.notes_contract && currentUser.notes_contract.length > 0">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'old_contract' ? 'current' : ''" (click)="toggleModal('old_contract')">
    <h3>{{ "CONTRACTS_HISTORY" | translate }}</h3>
  </div>
  <!--sub toggle-->
  <div class="card-body row pb-0" *ngIf="openContractTab == 'old_contract'">
    <div class="col-12 border-top" *ngFor="let item of currentUser.notes_contract">
      <div class="row cursor-pointer py-2" (click)="item.open = !item.open">
        <h4 class="m-0 col-12 toggle-header font-medium-1 font-weight-normal" [ngClass]="item.open ? 'current' : ''">
          {{ ("EDITED_IN_DATE" | translate) + " " + _utilsService.formatDate(item.insert_date, "DD/MM/YYYY") }}
        </h4>
      </div>
      <!-- label sub toggle -->
      <div class="row border-top" [ngClass]="item.open ? '' : 'd-none'">
        <div class="contract-log-detail px-2 py-1" [innerHTML]="item.note"></div>
      </div>
    </div>
  </div>
</div>

<!-- documentazione privata e contratto -->
<div class="card">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'private_documentation' ? 'current' : ''" (click)="toggleModal('private_documentation')">
    <h3>{{ "PRIVATE_DOCUMENTATION_AND_CONTRACT_FILE" | translate }}</h3>
  </div>
  <div class="card-body border-top row pt-2" *ngIf="openContractTab == 'private_documentation'">
    <div class="col-12">
      <!-- caricamento contratto-->
      <div class="form-group col-12">
        <h4 class="m-0">{{ "UPLOAD_CONTRACT" | translate }}</h4>
      </div>
      <div class="form-group col-12 d-flex">
        <div class="custom-file flex-basis-33">
          <input class="custom-file-input" type="file" lang="it" accept="application/pdf" (change)="handlerChangeContractFile($event)" />
          <label *ngIf="!fileNameContract" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
          <label *ngIf="fileNameContract && fileNameContract.length > 0" class="custom-file-label">{{ fileNameContract }}</label>
        </div>
        <button *ngIf="fileContract" class="btn btn-primary ml-2" (click)="uploadContract()">{{ "UPLOAD_CONTRACT" | translate }}</button>
      </div>
      <!-- upload altri documenti-->
      <div class="border-top pt-2 mt-2 col-12" id="attachmentSection" *ngIf="_utilsService.isDesktop && currentUser.type_code === 'employee'">
        <h4 class="m-0">{{ "UPLOAD_ATTACHMENTS" | translate }}</h4>
        <div class="form-group d-flex justify-content-between align-items-center mt-1">
          <div class="custom-file flex-basis-33">
            <input class="custom-file-input" type="file" lang="it" accept="application/pdf" [multiple]="true" (change)="handlerChangeContractAttachments($event)" />
            <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
          </div>
          <div class="text-right" *ngIf="contractAttachmentsList_obj.length > 0 && !isUploading">
            <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
            <button class="btn btn-primary ml-1" (click)="uploadFiles()">{{ "UPLOAD_ATTACHMENTS" | translate }}</button>
          </div>
        </div>
        <div class="col-12 px-0 py-1" *ngIf="contractAttachmentsList_obj.length > 0">
          <div *ngFor="let file of contractAttachmentsList_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
            <div class="flex-basis-60 d-flex align-items-center">
              <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                <i [data-feather]="'x'" class="text-danger" size="18"></i>
              </div>
              <div class="mt-025">{{ file.name }}</div>
            </div>
            <div class="flex-basis-20 text-right">
              <span class="badge badge-light-info" *ngIf="file.status === 0">{{ "STATUS.PENDING" | translate }}</span>
              <span class="badge badge-light-secondary" *ngIf="file.status === 1">{{ "STATUS.PROCESSING" | translate }}</span>
              <span class="badge badge-light-success" *ngIf="file.status === 2">{{ "STATUS.COMPLETED" | translate }}</span>
              <span class="badge badge-light-danger" *ngIf="file.status === 3">{{ "STATUS.ERROR" | translate }}</span>
            </div>
            <div class="flex-basis-20 text-right">{{ file.size }}</div>
          </div>
          <div class="mt-1">{{ "TOTAL" | translate }}: {{ contractAttachmentsList_obj.length }}</div>
        </div>
      </div>
      <!-- lista documenti -->
      <div class="col-12 border-top pt-2 mt-1" [ngClass]="currentUser.type_code === 'employee' ? 'mt-2' : ''" *ngIf="currentUser.contract?.contract_attachments?.length > 0 || currentUser.contract_url">
        <div class="form-group">
          <h4 class="m-0">{{ "UPLOADED_DOCUMENTS" | translate }}</h4>
        </div>
        <!-- bottone di visualizzazione contratto da mantenere -->
        <div>
          <button class="btn btn-outline-primary mr-075 mb-075" *ngIf="currentUser.contract_url" type="button" (click)="viewDocument(currentUser.contract_url)">{{ "VIEW_CURRENT_CONTRACT" | translate }}</button>
          <button class="btn btn-outline-warning mr-075 mb-075" *ngIf="currentUser.file_dimissional" type="button" (click)="viewDocument(currentUser.file_dimissional)">{{ "FILE_DIMISSIONS" | translate }}</button>
          <div class="row">
            <div class="col-12 d-flex align-items-center py-1 border-bottom" *ngFor="let userAttachment of currentUser.contract.contract_attachments">
              <button class="bg-transparent border-0 text-primary" type="button" (click)="viewDocument(userAttachment.url)">
                <i [data-feather]="'eye'" size="19"></i>
              </button>
              <button class="bg-transparent border-0 text-danger remove-item" type="button" (click)="deleteAttachments(userAttachment)" *ngIf="_authenticationService.hasCapability('delete_employee_attachments')">
                <i [data-feather]="'trash-2'" size="19"></i>
              </button>
              <span>{{ userAttachment.file_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ferie e permessi non goduti-->
<div class="card">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'holidays_and_permissions' ? 'current' : ''" (click)="toggleModal('holidays_and_permissions')">
    <div>
      <h3>{{ "HOLIDAYS_AND_PERMISSIONS" | translate }}</h3>
      <small>{{ 'LAST_UPDATE' | translate }}: {{ _utilsService.formatDate(_utilsService.themeConfiguration.last_update_residual_absences) }}</small>
    </div>
  </div>
  <div class="card-body border-top row pt-2" *ngIf="openContractTab == 'holidays_and_permissions'" [formGroup]="updateAbsencesFormGroup">
    <div class="form-group col-xl-4 col-md-6 col-12">
      <label for="absence_holidays">{{ "HOLIDAYS_NOT_TAKEN" | translate }} ({{ "DAYS" | translate }})</label>
      <input type="number" id="absence_holidays" class="form-control" formControlName="residual_holidays" />
    </div>
    <div class="form-group col-xl-4 col-md-6 col-12">
      <label for="absence_permissions">{{ "PERMISSION_NOT_TAKEN" | translate }} ({{ "HOURS" | translate }})</label>
      <input type="number" id="absence_permissions" class="form-control" formControlName="residual_permissions" />
    </div>
    <div class="form-group col-xl-4 col-md-6 col-12 text-right">
      <button type="button" class="btn btn-primary mt-2" [disabled]="updateAbsencesFormGroup.invalid" (click)="saveResidualAbsences()">{{ "SAVE" | translate }}</button>
    </div>
  </div>
</div>

<!-- dimissioni e licenziamento -->
<div class="card">
  <div class="card-header toggle-header" [ngClass]="openContractTab == 'resignation_fire' ? 'current' : ''" (click)="toggleModal('resignation_fire')">
    <h3>{{ "RESIGNATION_OR_FIRE_FIELDS" | translate }}</h3>
  </div>
  <div class="card-body border-top row pt-2" *ngIf="openContractTab == 'resignation_fire'">
    <div class="form-group col-xl-4 col-md-6 col-12">
      <label for="resignation-upload">{{ "DATATABLE_COLUMNS.TYPE" | translate }}</label>
      <select class="form-control" [(ngModel)]="typeResignation" [disabled]="is_resigned">
        <option value="resignation" selected>{{ "RESIGNATION" | translate }}</option>
        <option value="dismissal">{{ "DISMISSAL" | translate }}</option>
      </select>
    </div>
    <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="currentUser.contract">
      <label for="resignation-upload">{{ (typeResignation === "resignation" ? "RESIGNATION_FILE" : "DISMISSAL_FILE") | translate }}</label>
      <fieldset *ngIf="!currentUser.contract.resignation_url && !currentUser?.contract?.file_dimissional">
        <div class="custom-file">
          <input class="custom-file-input" type="file" lang="it" id="resignation-upload" accept="application/pdf" (change)="handlerChangeFileInput($event); contract_is_changed = true" />
          <label *ngIf="!fileNameResignation" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
          <label *ngIf="fileNameResignation && fileNameResignation.length > 0" class="custom-file-label">{{ fileNameResignation }}</label>
        </div>
      </fieldset>
      <div *ngIf="currentUser.contract.resignation_url || currentUser.contract.file_dimissional">
        <div class="mt-05 badge badge-pill badge-success">{{ "FILE_ALREADY_UPLOADED" | translate }}</div>
      </div>
    </div>
    <div class="form-group col-xl-4 col-md-6 col-12">
      <label for="closed_at">{{ "CLOSED_AT" | translate }}</label>
      <input [min]="today_date" type="date" id="closed_at" class="form-control" [readonly]="is_resigned" (change)="contract_is_changed = true" [(ngModel)]="_manageContract.data.closed_at" />
    </div>
    <div class="form-group col-12">
      <label for="closed_reason">{{ "CLOSED_REASON" | translate }}</label>
      <textarea id="closed_reason" class="form-control" [readonly]="is_resigned" (change)="contract_is_changed = true" [(ngModel)]="_manageContract.data.closed_reason"></textarea>
    </div>
  </div>
  <div class="card-footer" *ngIf="openContractTab == 'resignation_fire'">
    <button *ngIf="!is_resigned" class="btn btn-primary" type="button" (click)="saveResignation()">{{ "SAVE" | translate }}</button>
    <button *ngIf="is_resigned" class="btn btn-primary" type="button" (click)="revokeResignation()">{{ "REVOKE_RESIGNATION_OR_DIMISSIONS" | translate }}</button>
  </div>
</div>